import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { birthdayslogin } from '../actions/auth';
import Spinner from './layout-spinner/Spinner';

// app.ricotta.team/birthdays/billing or app.ricotta.team/birthdays/dashboard

// the onSubmit part will go into pagebilling

const BirthdaysPageBilling = ({ birthdayslogin, birthdaysisAuthenticated, birthdaysisLoading }) => {
    useEffect(() => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let code = params.get('code');
        birthdayslogin(code);

        // window.location.href = "http://stackoverflow.com";

    }, []);

 


    if (birthdaysisAuthenticated) {
        return <Redirect to='/birthdays/dashboard/index' />;
    }

    return <Spinner />
};

BirthdaysPageBilling.propTypes = {
    birthdayslogin: PropTypes.func.isRequired,
    birthdaysisAuthenticated: PropTypes.bool,
    birthdaysisLoading: PropTypes.bool
  };
  
const mapStateToProps = state => ({
    birthdaysisAuthenticated: state.auth.birthdaysisAuthenticated,
    birthdaysisLoading: state.auth.birthdaysloading
});

export default connect(mapStateToProps, {birthdayslogin})(BirthdaysPageBilling);

